import { useEffect, useSyncExternalStore } from 'react';

import {
  FeaturesStatus,
  getFeaturesSnapshot,
  loadFeatures,
  subscribeFeatures,
} from '../_helpers/features.js';

/**
 * One operator feature flag from `GET /public/features` (ENG-782, ENG-783),
 * shared by every component on the page: the first caller starts the one
 * request (`_helpers/features.js`), everyone re-renders when it answers.
 *
 * `enabled` fails closed: false while the request is pending, false when it
 * failed (it is retried at 5s and 30s), and true only when the backend said
 * exactly `true`. `resolved` is true once an answer is in, either way.
 */
export const useFeatureFlag = (name) => {
  const snapshot = useSyncExternalStore(subscribeFeatures, getFeaturesSnapshot, getFeaturesSnapshot);

  useEffect(() => {
    loadFeatures();
  }, []);

  return {
    enabled: snapshot.flags[name] === true,
    resolved: snapshot.status !== FeaturesStatus.LOADING,
  };
};

export default useFeatureFlag;
